import { ClientDetailsForm } from "../components/clients/ClientDetailsForm";
import { Section } from "../components/Section";

export function NewClientPage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New Organization</Section.Title>
      <ClientDetailsForm />
    </div>
  );
}
